// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3K15d","approved":"Status_approved__N89J_","rejected":"Status_rejected__2fPTj","expired":"Status_expired__1YolT","label":"Status_label__vq7Ih"};